import { FC, ReactNode } from 'react';

import { cn } from 'components/lib/utils';

import {
  NAV_BUTTON_BASE_CLASSES,
  NAV_BUTTON_DISABLED_CLASSES
} from './MonthPicker.consts';

export interface IYearNavButtonProps {
  testId: string;
  ariaLabel: string;
  icon: ReactNode;
  isEnabled: boolean;
  onNavigate: () => void;
}

export const YearNavButton: FC<IYearNavButtonProps> = ({
  testId,
  ariaLabel,
  icon,
  isEnabled,
  onNavigate
}) => (
  <button
    type="button"
    data-testid={testId}
    aria-label={ariaLabel}
    disabled={!isEnabled}
    onClick={onNavigate}
    className={cn(
      NAV_BUTTON_BASE_CLASSES,
      !isEnabled && NAV_BUTTON_DISABLED_CLASSES
    )}
  >
    {icon}
  </button>
);
